"use client";

import { useRouter } from "@/i18n/navigation";
import type { Route } from "next";
import { Pagination } from "@wmart/ui";

/**
 * Thin client wrapper around `<Pagination>` for the catalog page.
 *
 * V1.0's storefront API is forward-cursor-only: each list response carries
 * `nextCursor` but no `prevCursor`. We approximate "previous" by stepping
 * back through browser history (router.back()) when `hasPrev` is true (a
 * cursor was applied to the current URL).
 *
 * `nextHref` is fully-formed on the server (catalog page builds it from
 * the current querystring + the new cursor) so this component is purely
 * navigation glue — it never has to know which filters are active.
 */
export function CatalogPagination({
  hasPrev,
  nextHref,
}: {
  hasPrev: boolean;
  nextHref: string | null;
}) {
  const router = useRouter();
  return (
    <Pagination
      className="mt-8"
      hasPrev={hasPrev}
      hasNext={!!nextHref}
      onPrev={() => router.back()}
      onNext={() => {
        if (nextHref) router.push(nextHref as Route);
      }}
    />
  );
}
